/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ msg: NonNullable<unknown> }} Product_Image_Upload_ErrorInputs */

const vi_product_image_upload_error = /** @type {(inputs: Product_Image_Upload_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tải ảnh thất bại: ${i?.msg}`)
};

/**

* @param {Product_Image_Upload_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_image_upload_error = /** @type {((inputs: Product_Image_Upload_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Image_Upload_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_image_upload_error(inputs)
});